import { AbstractPmsApiService } from "./abstract.service";
import { User, Role } from "../models";

/**
 * @class UserPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<User>}
 */
export class UserPmsApiService extends AbstractPmsApiService {
    
    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {
        
        return '/user(/:id)';
    }
    
    /**
     * @param {Object.<string, *>} attributes
     * @returns {User}
     * @protected
     */
    newModel(attributes) {
        
        return new User(attributes);
    }
    
    /**
     * @param {Object} params
     * @returns {Promise.<PaginationCollection<User>>}
     */
    get (params = {}) {
        
        const url = this.url();
        const ignoreLB = params.hasOwnProperty('searchValue');
        return this.http
                   .get(url, {
                       headers: this.authHeaders,
                       params,
                       ignoreLoadingBar: ignoreLB
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {User} user
     * @returns {Promise.<User>}
     */
    show(user) {
        
        const url = this.url({id: user.id});
        
        return this.http
                   .get(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {User} user
     * @returns {Promise.<User>}
     */
    create(user) {
        
        const url = this.url();
        
        return this.http
                   .post(url, user, {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {User} user
     * @returns {Promise.<User>}
     */
    update(user) {
        
        const url = this.url({id: user.id});
        
        return this.http
                   .put(url, user.toObject('name', 'email'), {
                       headers: this.authHeaders
                   })
                   .then(this.getModeler())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {User} user
     * @returns {Promise.<boolean>}
     */
    delete(user) {
        
        const url = this.url({id: user.id});
        
        return this.http
                   .delete(url, {
                       headers: this.authHeaders
                   })
                   .then(this.getStatusExtractor())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Object} params
     * @returns {Promise.<User>[]}
     */
    businessOwnerList(params = {}) {
        
        let url = this.url();
        
        return this.http
                   .get(url + '/business-owners', {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getMassModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     * @param {Object} params
     * @returns {Promise.<User>[]}
     */
    adminRolesList(params = {}) {

        let url = this.url();

        return this.http
            .get(url + '/admin-roles', {
                headers: this.authHeaders,
                params
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Property} property
     * @returns {Promise.<User>[]}
     */
    propertyUserList(property, params = {}) {
        
        return this.http
                   .get(`${this.endpoint}/property/${property.id}/user`, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getPaginationCollector())
                   .catch(this.getErrorHandler());
    }
    
    /**
     * @param {Integer} propertyId
     * @param {Object} params
     * @returns {Promise.<User>[]}
     */
    propertyAllUsersList(propertyId, params = {}) {
        
        return this.http
                   .get(`${this.endpoint}/property/${propertyId}/all-users`, {
                       headers: this.authHeaders,
                       params
                   })
                   .then(this.getMassModeler())
                   .catch(this.getErrorHandler());
    }

    /**
     *
     * @param {Object} model
     * @returns {Promise.<User>}
     */
    changePassword(model) {

        const url = this.url();

        return this.http
            .post(url + '/change-password', model, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    businessOwnerWithDeletedProperties(params = {}) {

        const url = this.url({
            id: 'with-deleted-properties',
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getMassModeler())
            .catch(this.getErrorHandler());
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/user.service.js